module.exports = __webpack_public_path__ + "img/Spore_Firma_RGB.b4006f3e.png";